import JsonEditor from "../../../../../CommonComponents/json_editor/JsonEditor";

interface JsonEditorViewProps {
    jsonData: object;
    jsonInput: string;
    jsonError: string | null;
    count: number;
    onJsonChange: (value: string | undefined) => void;
    onEditorMount?: (editor: any, monaco: any) => void;
}

const JsonEditorView = ({ jsonData, jsonInput, jsonError, count, onJsonChange, onEditorMount }: JsonEditorViewProps) => (
    <>
        <div
            className="json-view"
            style={{
                padding: "0px",
                backgroundColor: Object.keys(jsonData).length > 0 ? "" : "transparent",
            }}
            onMouseDown={(e) => e.stopPropagation()}
        >
            {Object.keys(jsonData).length > 0 && (
                <JsonEditor
                    defaultValue={jsonInput}
                    editable={true}
                    onChange={onJsonChange}
                    backgroundColor="transparent"
                    count={count}
                    onMount={onEditorMount}
                />
            )}
        </div>
        {jsonError && <div className="error">{jsonError}</div>}
    </>
);

export default JsonEditorView;
